const mainTheme = {
  color: {
    primary: '#18263F',
    secondary: '#FFCD0A',
    grey: '#E5E5E5',
    dark: '#1C1C1C',
    light: '#FFFFFF',
  },

  font: {
    family: {
      primary: 'proxima-nova, sans-serif',
      secondary: 'Verdana, Arial',
    },

    size: {
      tiny: '10px',
      small: '14px',
      medium: '16px',
      big: '18px',
      large: '24px',
      huge: '30px',
      mega: '40px',
      giga: '60px',
    },

    weight: {
      light: 300,
      regular: 400,
      bold: 600,
      extraBold: 800,
    },
  },
}

export default mainTheme
